<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <div
                v-if="exibirQuantidade"
                class="text-center"
              >
                Quantidade Atual
              </div>
              <div
                v-if="exibirQuantidade"
                id="valorFaturamentoCliente"
                class="text-center"
              >
                {{ quantidadeCliente }}
              </div>
              <div
                v-if="exibirQuantidade"
                class="text-center"
              >
                Quantidade Ano Anterior
              </div>
              <div
                v-if="exibirQuantidade"
                id="valorFaturamentoClienteAnterior"
                class="text-center"
              >
                {{ quantidadeClienteAnterior }}
              </div>
              <div
                class="text-center"
              >
                <dashboard-porcentagem-quantidade-cliente />
              </div>
              <div
                class="text-center"
              >
                <dashboard-evolucao-quantidade-cliente />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../../services/clientes'
  import eventEmit from '../../../core/EventoEmit'

  export default {
    name: 'ShowExtratoClientesFaturados',
    emits: ['setQuantidadeDadosCliente', 'setQuantidadePorcentagemCliente'],
    components: {
      DashboardPorcentagemQuantidadeCliente: () => import('../../../../graficos/Clientes/ExtratoClientes/PorcentagemQuantidade'),
      DashboardEvolucaoQuantidadeCliente: () => import('../../../../graficos/Clientes/ExtratoClientes/EvolucaoQuantidadeCliente'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      categoria: [],
      promotor: [],
      selectCliente: JSON.parse(localStorage.clienteSelect),
      exibirQuantidade: false,
      quantidadeCliente: 0,
      quantidadeClienteAnterior: 0,
    }),

    created () {
      eventEmit.$on('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectCliente, vendedor, area, rede, supervisor, receita, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectCliente = selectCliente
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosQuantidadeCliente()
      },

      async showDadosQuantidadeCliente () {
        this.loading = true
        this.exibirQuantidade = false

        this.quantidadeCliente = 0
        this.quantidadeClienteAnterior = 0

        await Clientes.showQuantidadeCliente(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.quantidadeCliente = resposta.data.quantidadeCliente

            this.quantidadeClienteAnterior = resposta.data.quantidadeClienteAnterior

            eventEmit.$emit('set-quantidade-porcentagem-cliente', resposta.data.porcentagemAtual, resposta.data.porcentagemAnterior)

            eventEmit.$emit('set-quantidade-dados-cliente', resposta.data.dadosFaturamento, resposta.data.labels)
          } else if (resposta.data.msg === 'Não há faturamento para o(s) cliente(s) selecionado') {
            this.quantidadeCliente = 0

            this.quantidadeClienteAnterior = 0

            eventEmit.$emit('set-quantidade-porcentagem-cliente', 0, 0)

            eventEmit.$emit('set-quantidade-dados-cliente', 0, 0)

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirQuantidade = true
        })
      },

    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
